<template>
    <div v-if="popupsControlStore.citySelectPopupVisible"
         class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 transition-opacity"
         @click="handleBackgroundClick">
        <div ref="citySelectPopupRef"
             class="relative bg-white md:rounded-3xl shadow-lg w-full md:w-[90%] h-full max-h-full md:max-h-[90vh] overflow-hidden p-6 md:p-10 flex flex-col">
            <button type="button"
                    class="absolute top-3 right-3 text-gray-500 md:hover:text-gray-700"
                    @click="popupsControlStore.closeCitySelectPopup">
                <IconX class="w-8 h-8"/>
            </button>
            <h2 class="text-xl font-semibold text-gray-800 mb-4">Выберите город</h2>
            <input v-model="search" type="text" placeholder="Введите название"
                   class="mb-4 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-baseColor focus:ring-0"/>
            <div class="overflow-y-auto">
                <div v-for="(city, key) in filteredCities" :key="key" class="mb-6">
                    <button type="button" class="hover:text-navHoverColor md:hover:underline transition"
                            @click="selectCity(city)">
                        {{ city.name }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {ref, computed} from 'vue';
import IconX from "@js/components/Icons/IconX.vue";
import {usePopupsControlStore} from "@js/store/PopupsControlStore.js";
import {cities} from "@js/cities.ts";

export default {
    name: 'CitySelector',
    components: {IconX},
    setup() {
        const popupsControlStore = usePopupsControlStore();
        const citySelectPopupRef = ref(null);
        const search = ref('');

        const handleBackgroundClick = (event) => {
            if (
                citySelectPopupRef.value &&
                !citySelectPopupRef.value.contains(event.target)
            ) {
                popupsControlStore.closeCitySelectPopup();
            }
        };

        const selectCity = (city) => {
            popupsControlStore.selectedCity = city;
            popupsControlStore.closeCitySelectPopup()
        };

        const filteredCities = computed(() =>
            cities.filter(city =>
                !search.value ||
                city.name.toLowerCase().includes(search.value.trim().toLowerCase())
            )
        );

        return {
            popupsControlStore,
            citySelectPopupRef,
            handleBackgroundClick,
            search,
            selectCity,
            filteredCities
        };
    },
};
</script>
